import { FC } from "react";
import CustomPopup from "../../../components/CustomPopup/CustomPopup";
import { defaultEmptyFun } from "../../../utils/helper";
import { tabViewPoint } from "../../../utils/constants";
import useWindowSize from "../../../hooks/useWindowSize";
import CloseIcon from "@mui/icons-material/Close";
import NotificationPopupBody from "./NotificationPopupBody";
import { Drawer } from "@mui/material";

interface NotificationDrawerProps {
  openData: boolean;
  handleOpenData?: Function;
}

const NotificationDrawer: FC<NotificationDrawerProps> = ({
  openData = false,
  handleOpenData = defaultEmptyFun,
}) => {
  const { width } = useWindowSize();
  return (
    <>
      {width >= tabViewPoint ? (
        <CustomPopup
          open={openData}
          handleOpen={() => handleOpenData(false)}
          btnLabel="Close"
          btnStartIcon={<CloseIcon fontSize="small" />}
          className="notification-popup"
        >
          <NotificationPopupBody />
        </CustomPopup>
      ) : (
        <Drawer
          open={openData}
          anchor="bottom"
          onClose={() => handleOpenData(false)}
          className="notification-drawer"
        >
          <NotificationPopupBody />
        </Drawer>
      )}
    </>
  );
};

export default NotificationDrawer;
